export default "__VITE_ASSET__903b9398__"